import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "brg-pagination__start" };
const _hoisted_2 = { class: "brg-pagination__center" };
const _hoisted_3 = { class: "brg-pagination__end" };
import { computed, toRefs, } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BrgPagination',
    props: {
        modelValue: { default: 1 },
        length: { default: 1 },
        totalVisible: { default: 10 },
        className: { default: 'mt-1' }
    },
    setup(__props) {
        const props = __props;
        const { modelValue, length, totalVisible, className, } = toRefs(props);
        // 페이지 없을 때 최소 1이라고 출력 되도록 처리
        const l = computed(() => (length.value === 0 ? 1 : length.value));
        return (_ctx, _cache) => {
            const _component_v_pagination = _resolveComponent("v-pagination");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["brg-pagination", _unref(className)])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "start")
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" 페이지네이션 "),
                    (_unref(modelValue) >= 0 && l.value >= 0)
                        ? (_openBlock(), _createBlock(_component_v_pagination, {
                            key: 0,
                            density: "comfortable",
                            color: "#424242",
                            "model-value": _unref(modelValue),
                            border: true,
                            length: l.value,
                            "total-visible": _unref(totalVisible),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', $event)))
                        }, null, 8 /* PROPS */, ["model-value", "length", "total-visible"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" 우측 영역 (마지막 영역) "),
                _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "end")
                ])
            ], 2 /* CLASS */));
        };
    }
});
